import {useHistory} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {fetchAllRatingProgramsService} from "../../services/rating.service";
import Loader from "../../ui_library/ver_24.10/Loader/Loader.comp";
import RatedProgramsDQAssessmentListView from "../../views/ver_24.10/ProgramRating/RatedProgramsDQAssessmentList.view";
import {APP_STATUS} from "../../utils/constants";

const RatedProgramsDQAssessmentList = () => {
    const history = useHistory();
    const [showLoader, setShowLoader] = useState(false);
    const [ratingPrograms, setRatingPrograms] = useState([]);

    useEffect(() => {
        setShowLoader(true);
        initializeFetchAllRatingPrograms().then(resp => setShowLoader(false)).catch(err => setShowLoader(false));
    }, []);

    const initializeFetchAllRatingPrograms = async () => {
        setShowLoader(true);
        try {
            const result = await fetchAllRatingProgramsService();
            if (result && result.data) {
                console.log('programs_fetched: ', result.data.all_program_applications);

                const filteredPrograms = result.data.all_program_applications.filter(
                    (program) => program.app_status >= 100
                );

                setRatingPrograms(filteredPrograms);
            }

        } catch (e) {
            // already toasted the error
        }
        setShowLoader(false);
    };

    const data = {
        ratingPrograms,
    };

    const actions = {

        accessAssessmentAction: (programId, program_status) => {
            if (program_status === APP_STATUS.ASSESSMENTS_PUBLISHED) {
                history.push(`/rating/${programId}/access_assessment`);
            } else if (program_status === APP_STATUS.ASSESSMENTS_READY) {
                history.push(`/rating/${programId}/select_assessment`);
            } else {
                history.push(`/rating/${programId}/welcome_assessment`);
            }
        },

        createAssessmentAction: () => {
            history.push(`/assessment/new`);
        },
    }

    const options = {
    };

    if (showLoader) {
        return <Loader />;
    }

    return (
        <>
            <div>
                <RatedProgramsDQAssessmentListView data={data} actions={actions} options={options}/>
            </div>
        </>
    );

}

export default RatedProgramsDQAssessmentList;